import React from "react";
import Toast from "./Toast";
import { connect } from "react-redux";
import { map } from "lodash";
import * as appActions from "../../../_actions/appActions";
import getToasts from "../../../_selectors/appSelectors/getToasts";

const ToastContainer = ({ toasts, hide }) => {
  return (
    <div className="iziToast-wrapper iziToast-wrapper-topRight">
      {map(toasts, toast => (
        <Toast
          key={toast.id}
          timeout={toast.timeout}
          type={toast.type}
          message={toast.message}
          image={toast.image}
          title={toast.title}
          onClick={() => {
            if (toast.onClick) {
              toast.onClick();
              hide(toast.id);
              if (toast.onClose) {
                toast.onClose();
              }
            }
          }}
          onClose={() => {
            hide(toast.id);
            if (toast.onClose) {
              toast.onClose();
            }
          }}
        />
      ))}
    </div>
  );
};
const mapStateToProps = (state, ownProps) => ({
  toasts: getToasts(state)
});
const mapDispatchToProps = dispatch => ({
  hide: payload => dispatch(appActions.hideToast(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToastContainer);



// WEBPACK FOOTER //
// ./src/_components/Layout/ToastContainer/index.js